// تعریف نوع رویدادهای ناوبری
export type NavigationEvent = {
  type: 'REDIRECT_TO_LOGIN' | 'REDIRECT_TO_UNAUTHORIZED' | 'REDIRECT_TO';
  path?: string;
};

// نام رویداد سفارشی
const NAVIGATION_EVENT_NAME = 'app:navigation';

/**
 * سرویس ناوبری بدون رفرش صفحه
 */

// ذخیره callback های ناوبری 
let redirectCallback: ((path: string) => void) | null = null;
let loginCallback: (() => void) | null = null;
let unauthorizedCallback: (() => void) | null = null;

/**
 * سرویس ناوبری برای مدیریت ریدایرکت‌ها بدون رفرش
 */
const navigationService = {
  /**
   * ثبت callback های ناوبری
   */
  registerCallbacks: (
    onRedirect: (path: string) => void,
    onLogin: () => void,
    onUnauthorized: () => void
  ) => {
    redirectCallback = onRedirect;
    loginCallback = onLogin;
    unauthorizedCallback = onUnauthorized;
    console.log('Navigation callbacks registered');
  },

  /**
   * حذف callback های ناوبری
   */
  unregisterCallbacks: () => {
    redirectCallback = null;
    loginCallback = null;
    unauthorizedCallback = null;
  },

  /**
   * ریدایرکت به صفحه لاگین بدون رفرش صفحه
   */
  redirectToLogin: () => {
    console.log('============ Navigation service: redirectToLogin called ============');

    try {
      // پاک کردن همه داده‌های localStorage
      localStorage.clear();
      console.log('Cleared all localStorage data');

      // پاک کردن کوکی‌ها
      document.cookie.split(";").forEach(function (c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
      console.log('Cleared cookies');

      // اجرای callback در صورت وجود
      if (loginCallback) {
        console.log('Executing login callback');
        loginCallback();

        // اگر callback اجرا نشد، مستقیماً به صفحه لاگین برو
        setTimeout(() => {
          if (window.location.pathname !== '/login') {
            console.log('Fallback: direct redirection to login page');
            window.location.href = '/login';
          }
        }, 300);
      } else {
        console.warn('Login callback not registered, using direct redirection');
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Error in redirectToLogin:', error);
      // در صورت خطا، مستقیماً به صفحه لاگین برو
      window.location.href = '/login';
    }
  },

  /**
   * ریدایرکت به صفحه عدم دسترسی بدون رفرش صفحه
   */
  redirectToUnauthorized: () => {
    console.log('============ Navigation service: redirectToUnauthorized called ============');

    try {
      // اجرای callback در صورت وجود
      if (unauthorizedCallback) {
        console.log('Executing unauthorized callback');
        unauthorizedCallback();

        // اگر callback اجرا نشد، مستقیماً به صفحه عدم دسترسی برو
        setTimeout(() => {
          if (window.location.pathname !== '/unauthorized') {
            console.log('Fallback: direct redirection to unauthorized page');
            window.location.href = '/unauthorized';
          }
        }, 300);
      } else {
        console.warn('Unauthorized callback not registered, using direct redirection');
        window.location.href = '/unauthorized';
      }
    } catch (error) {
      console.error('Error in redirectToUnauthorized:', error);
      // در صورت خطا، مستقیماً به صفحه عدم دسترسی برو
      window.location.href = '/unauthorized';
    }
  },

  /**
   * ریدایرکت به مسیر دلخواه بدون رفرش صفحه
   */
  redirectTo: (path: string) => {
    console.log('Navigation service: redirectTo called', path);
    if (redirectCallback) {
      console.log('Executing redirect callback');
      redirectCallback(path);
    } else {
      console.warn('Redirect callback not registered');
    }
  },

  /**
   * گوش دادن به رویدادهای ناوبری
   * این متد باید در یک کامپوننت React که به React Router دسترسی دارد فراخوانی شود
   */
  listenToNavigationEvents: (
    onRedirect: (path: string) => void,
    onLogin: () => void,
    onUnauthorized: () => void
  ) => {
    const handleNavigation = (event: Event) => {
      const navigationEvent = (event as CustomEvent<NavigationEvent>).detail;

      switch (navigationEvent.type) {
        case 'REDIRECT_TO_LOGIN':
          onLogin();
          break;
        case 'REDIRECT_TO_UNAUTHORIZED':
          onUnauthorized();
          break;
        case 'REDIRECT_TO':
          if (navigationEvent.path) {
            onRedirect(navigationEvent.path);
          }
          break;
      }
    };

    // اضافه کردن شنونده رویداد
    window.addEventListener(NAVIGATION_EVENT_NAME, handleNavigation);

    // بازگرداندن تابع برای حذف شنونده
    return () => {
      window.removeEventListener(NAVIGATION_EVENT_NAME, handleNavigation);
    };
  }
};

// Add Settings link
const systemMenuItems = [
  {
    text: 'تنظیمات سیستم',
    icon: 'settings',
    to: '/settings',
    requiredPermissions: ['admin_setting_read']
  }
];

export default navigationService; 